import * as React from "react";

const Search: React.FC = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="presentation"
        >
            <path
                d="M10.5 19C14.9183 19 18.5 15.4183 18.5 11C18.5 6.58172 14.9183 3 10.5 3C6.08172 3 2.5 6.58172 2.5 11C2.5 15.4183 6.08172 19 10.5 19Z"
                stroke="#545454"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M20.9999 21L16.6499 16.65"
                stroke="#545454"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

export default React.memo(Search);
